import { uniqueId } from 'lodash';
import { ToastItem, ToastType } from './types';

type ToastListener = (toasts: ToastItem[]) => void;
let toastListeners: ToastListener[] = [];

const toastTimeouts: Record<number, ReturnType<typeof setTimeout>> = {};

export const toastStore = {
  toasts: [] as ToastItem[],

  addToast(message: string, timeOut = 5000, type: ToastType) {
    this.removeToastsByMessage(message);
    const id = uniqueId() as unknown as number;
    this.toasts = [...this.toasts, { id, message, type }];
    this._notify();
    if (toastTimeouts[id]) {
      clearTimeout(toastTimeouts[id]);
    }
    toastTimeouts[id] = setTimeout(() => {
      this.removeToast(id);
    }, timeOut);
    return id;
  },

  removeToast(id: number) {
    this.toasts = this.toasts.filter((toast) => toast.id !== id);
    if (toastTimeouts[id]) {
      clearTimeout(toastTimeouts[id]);
      delete toastTimeouts[id];
    }
    this._notify();
  },

  updateToast(id: number, message: string, type: ToastType) {
    this.toasts = this.toasts.map((toast) => (toast.id === id ? { ...toast, message, type } : toast));
    this._notify();
  },

  subscribe(listener: ToastListener) {
    if (!toastListeners.includes(listener)) {
      toastListeners.push(listener);
    }
    listener(this.toasts);
    return () => {
      toastListeners = toastListeners.filter((l) => l !== listener);
    };
  },

  removeToastsByMessage(message: string) {
    const toRemove = this.toasts.filter((toast) => toast.message === message).map((toast) => toast.id);
    this.toasts = this.toasts.filter((toast) => toast.message !== message);
    toRemove.forEach((id) => {
      if (toastTimeouts[id]) {
        clearTimeout(toastTimeouts[id]);
        delete toastTimeouts[id];
      }
    });
    this._notify();
  },

  _notify() {
    const toastsCopy = [...this.toasts];
    toastListeners.forEach((listener) => listener(toastsCopy));
  },
};
